import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import MDButton from "components/MDButton";
import axios from "axios";

export default function PagosModal({ open, handleClose, usuarioId }) {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!usuarioId || !open) return;

    const fetchPagos = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/estudiantes/${usuarioId}/pagos`
        );
        setPagos(response.data);
      } catch (error) {
        console.error("Error al cargar los pagos:", error);
        setPagos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPagos();
  }, [usuarioId, open]);

  return (
    <Modal open={!!open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // padding responsive
          width: { xs: '90%', sm: 400, md: 500 }, // 🔥 clave
          maxHeight: '90vh', // evita que se salga de pantalla
          overflowY: 'auto', // scroll interno
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Historial de pagos
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : pagos.length > 0 ? (
          pagos.map((pago, idx) => (
            <Box
              key={idx}
              sx={{
                p: 2,
                mb: 2,
              }}
            >
              {/* Cabecera del pago */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle2">
                 {pago.fecha_pago}
                </Typography>
                <Typography variant="caption">
                  {pago.metodo_pago || "—"}
                </Typography>
              </Box>

              <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: "bold" }}>
                Total pagado: {Number(pago.monto_total).toFixed(2)} Bs
              </Typography>

              <Divider sx={{ my: 1 }} />

              {/* Detalles */}
              {pago.detalles.map((detalle, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    py: 0.5,
                  }}
                >
                  <Typography variant="body2">
                    {detalle.concepto || "Pago"}
                  </Typography>
                  <Typography variant="body2">
                    {Number(detalle.monto_pagado || 0).toFixed(2)} Bs
                  </Typography>
                </Box>
              ))}
            </Box>
          ))
        ) : (
          <Typography>No hay pagos registrados.</Typography>
        )}

        <MDButton
          variant="contained"
          color="primary"
          onClick={handleClose}
          fullWidth
          sx={{ mt: 2 }}
        >
          Cerrar
        </MDButton>
      </Box>
    </Modal>
  );
}
